import React from 'react';
import { useForm } from 'react-hook-form';

const withForm = (WrappedComponent) => (props) => {
	const formMethods = useForm();
	return <WrappedComponent formMethods={formMethods} {...props} />;
}

export default withForm;
